import { useEffect } from 'react'

import { Select } from '../Select'
import { useAsyncSelectStates } from '../Select.hooks'
import { SelectDropdownAsyncList } from '../SelectDropdownAsyncList'

function ButtonAsyncSelect({
  Control,
  EntityIcon,
  blocked,
  checkIsLastPage,
  controlProps,
  disabled,
  dropdownFloatingConfig,
  dropdownProps,
  error,
  getApiParamsLoadNext,
  getData,
  getDataItems,
  getPermissionsData,
  getSearchApiParam,
  getShowSelectedApiParam,
  initialItems,
  initialSearchValue,
  listProps,
  loadAllApiParams,
  multi,
  observerOptions,
  pagination,
  selectStatesRef,
  thresholdEndIndex,
  toPreparedItems,
  value,
  onChangeSearch,
  onClear,
  onSelectAll,
  onSelectItem,
  ...restProps
}) {
  const selectStates = useAsyncSelectStates({
    blocked,
    checkIsLastPage,
    disabled,
    dropdownFloatingConfig,
    getApiParamsLoadNext,
    getData,
    getDataItems,
    getPermissionsData,
    getSearchApiParam,
    getShowSelectedApiParam,
    initialItems,
    initialSearchValue,
    loadAllApiParams,
    multi,
    observerOptions,
    pagination,
    thresholdEndIndex,
    toPreparedItems,
    value,
    onChangeSearch,
    onSelectAll,
    onSelectItem,
  })

  const {
    activeIndex,
    context,
    elementsRef,
    floatingStyles,
    getFloatingItemProps,
    getFloatingProps,
    getReferenceProps,
    getThresholdItemProps,
    handleChangeSearch,
    handleClearSearch,
    handleClose,
    handleKeyDown,
    handleOpen,
    handleSelect,
    handleSelectAll,
    handleToggleOpen,
    handleToggleShowSelected,
    isOpen,
    loadingInitial,
    loadingMore,
    options,
    refs,
    searchValue,
    showSelected,
  } = selectStates

  useEffect(() => {
    if (selectStatesRef) {
      selectStatesRef.current = selectStates
    }
  }, [selectStates])

  return (
    <Select
      {...restProps}
      Control={Control}
      List={SelectDropdownAsyncList}
      activeIndex={activeIndex}
      contextProps={{
        EntityIcon,
        blocked,
        disabled,
        error,
        getFloatingItemProps,
        multi,
        searchValue,
        showSelected,
        value,
        onChangeSearch: handleChangeSearch,
        onClear,
        onClearSearch: handleClearSearch,
        onClose: handleClose,
        onOpen: handleOpen,
        onSelect: handleSelect,
        onSelectAll: handleSelectAll,
        onToggleOpen: handleToggleOpen,
        onToggleShowSelected: handleToggleShowSelected,
      }}
      controlProps={{
        ...controlProps,
        ...(listProps?.headerProps?.Search === null
          ? getReferenceProps({ disabled, onKeyDown: handleKeyDown })
          : null),
      }}
      dropdownProps={{
        ...dropdownProps,
        context,
        floatingStyles,
        getFloatingProps,
      }}
      isOpen={isOpen}
      listProps={{
        ...listProps,
        elementsRef,
        getThresholdItemProps,
        headerProps: {
          ...listProps?.headerProps,
          searchProps: {
            ...listProps?.headerProps?.searchProps,
            inputProps: {
              ...listProps?.headerProps?.searchProps?.inputProps,
              ...(listProps?.headerProps?.Search === null
                ? null
                : getReferenceProps({ disabled, onKeyDown: handleKeyDown })),
            },
          },
        },
        loadingInitial,
        loadingMore,
        moreItemsLoaderProps: {
          ...listProps?.moreItemsLoaderProps,
          hasText: true,
        },
      }}
      options={options}
      refs={refs}
    />
  )
}

export default ButtonAsyncSelect
